export default __webpack_public_path__ + "static/media/pretzelchip-image.a49d28ca.png";